import React from "react";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import TEXT from "../../../utils/text/pnudBook.json";
import SurveyGraphSection from "../../reusable/SurveyGraphSection/SurveyGraphSection";
import { CirclePacking } from "@ant-design/plots";
import createPNUDTitle from "../../../utils/functions/createPNUDTitle";
import "./PNUDCrime.css";
import DATA from "../../../utils/PNUD/crime.json";
import { getCountryName } from "../../../utils/constants/nameCountry";
import { formatNumber } from "../../../utils/functions/formatNumber";

export default function PNUDCrime({ textPlacement }) {
  const { language } = useCurrentLanguage();

  function CrimeGraph() {
    const config = {
      autoFit: true,
      legend: false,
      tooltip: {
        domStyles: {
          "g2-tooltip": {
            backgroundColor: "rgba(255,255,255,1)",
            opacity: 1,
            borderRadius: "20px",
            fontFamily: "Open Sans",
            fontSize: "14px",
          },
        },
        customItems: (items) => {
          if (items[0].name === "root") return null;
          items[0].name = getCountryName(items[0].name, language, true);
          items[0].value =
            (items[0].data.value === 1
              ? 0
              : formatNumber(items[0].data.value, language)) + "pp";

          return items;
        },
      },
      hierarchyConfig: {
        sort: (a, b) => b.depth - a.depth,
      },
      colorField: "type",
    };

    const config1 = {
      ...config,
      data: DATA["informative"]["data"],
      color: (params) => {
        if (params.name === "root") return "#FFFFFF";
        return "#253c59";
      },
      label: {
        style: {
          fontSize: 12,
          textAlign: "center",
          fill: "white",
          fontFamily: "Open Sans",
        },
        offset: 0,
        formatter: ({ name }) => {
          if (name === "root") return "";
          return `${getCountryName(name, language, true)}
${
  DATA["informative"]["data"]["children"].find((e) => e.name === name)["value"]
}pp`;
        },
      },
    };

    const config2 = {
      ...config,
      data: DATA["emotive"]["data"],
      label: {
        style: {
          fontSize: 12,
          textAlign: "center",
          fill: "white",
          fontFamily: "Open Sans",
        },
        offset: 0,
        formatter: ({ name }) => {
          if (name === "root") return "";
          return `${getCountryName(name, language, true)}
${DATA["emotive"]["data"]["children"].find((e) => e.name === name)["value"]}pp`;
        },
      },
      color: (params) => {
        if (params.name === "root") return "#FFFFFF";
        return "#bf8d30";
      },
    };

    return (
      <>
        <div className="pnud-crime-graph-container">
          <div className="pnud-crime-graph">
            <p>{TEXT["crime"]["informativeTitle"][language]}</p>
            <CirclePacking {...config1} />
          </div>
          <div className="pnud-crime-graph">
            <p>{TEXT["crime"]["emotiveTitle"][language]}</p>
            <CirclePacking {...config2} />
          </div>
        </div>
        <div className="pnud-legend">
          {TEXT["crime"]["legend"][language]} {TEXT["notePP"][language]}
        </div>
      </>
    );
  }

  return (
    <SurveyGraphSection
      graphID={"pnud-acceptance"}
      textPlacement={textPlacement}
      title={createPNUDTitle(TEXT["crime"]["title"], language)}
      description={TEXT["crime"]["description"][language]}
      language={language}
      graphComponent={<CrimeGraph />}
      note={TEXT["crime"]["note"][language]}
      source={TEXT["source"][language]}
    />
  );
}
